import React from 'react';
import { useNavigation } from '../NavigationContext';

const styles = `
  @import url('https://fonts.googleapis.com/css2?family=Playfair+Display:ital,wght@0,700;0,800;0,900;1,700&family=Inter:wght@300;400;500;600;700;800&display=swap');

  .ef-page * { box-sizing: border-box; margin: 0; padding: 0; }
  .ef-page { font-family: 'Inter', sans-serif; color: #0d1b3e; background: #ffffff; width: 100%; }

  /* ── Hero ── */
  .ef-hero { position: relative; padding: 100px 24px 120px; overflow: hidden; background: #fff; }
  .ef-hero-blob1 { position: absolute; top: -10%; right: -5%; width: 600px; height: 600px; border-radius: 50%; background: radial-gradient(circle, rgba(5,150,105,0.08), rgba(13,27,62,0.04)); filter: blur(90px); pointer-events: none; }
  .ef-hero-blob2 { position: absolute; bottom: -15%; left: -10%; width: 720px; height: 720px; border-radius: 50%; background: radial-gradient(circle, rgba(232,163,32,0.07), rgba(5,150,105,0.04)); filter: blur(90px); pointer-events: none; }
  .ef-hero-inner { max-width: 1200px; margin: 0 auto; display: grid; grid-template-columns: 1fr 1fr; gap: 64px; align-items: center; position: relative; z-index: 1; }
  @media (max-width: 900px) { .ef-hero-inner { grid-template-columns: 1fr; } .ef-hero-card { display: none; } }

  .ef-badge { display: inline-flex; align-items: center; gap: 8px; padding: 8px 16px; border-radius: 999px; background: #f0fdf4; border: 1px solid #bbf7d0; font-size: 13px; font-weight: 500; color: #166534; margin-bottom: 28px; }
  .ef-badge-dot { width: 8px; height: 8px; border-radius: 50%; background: #22c55e; display: inline-block; animation: ef-pulse 2s ease-in-out infinite; }
  @keyframes ef-pulse { 0%, 100% { box-shadow: 0 0 0 0 rgba(34,197,94,0.5); } 50% { box-shadow: 0 0 0 6px rgba(34,197,94,0); } }

  .ef-hero h1 { font-family: 'Playfair Display', Georgia, serif; font-size: clamp(1.8rem, 3.375vw, 2.85rem); font-weight: 800; line-height: 1.1; letter-spacing: -0.02em; color: #0d1b3e; margin-bottom: 24px; }
  .ef-gradient-text { background: linear-gradient(135deg, #059669 0%, #0d1b3e 100%); -webkit-background-clip: text; -webkit-text-fill-color: transparent; background-clip: text; }
  .ef-hero-sub { font-size: 1.1rem; color: #475569; line-height: 1.8; margin-bottom: 40px; }
  .ef-btn-group { display: flex; gap: 16px; flex-wrap: wrap; margin-bottom: 44px; }
  .ef-btn-primary { padding: 14px 28px; background: #0d1b3e; color: #fff; border: none; border-radius: 10px; font-size: 15px; font-weight: 600; cursor: pointer; display: inline-flex; align-items: center; gap: 8px; transition: all 0.2s; }
  .ef-btn-primary:hover { background: #059669; transform: translateY(-2px); box-shadow: 0 8px 24px rgba(5,150,105,0.3); }
  .ef-back-btn { display: flex; width: fit-content; align-items: center; gap: 8px; font-size: 14px; font-weight: 600; color: #059669; background: none; border: none; cursor: pointer; padding: 0; margin-bottom: 24px; transition: color 0.2s; }
  .ef-back-btn:hover { color: #047857; }
  .ef-btn-secondary { padding: 14px 28px; background: #fff; color: #0d1b3e; border: 1.5px solid #cbd5e1; border-radius: 10px; font-size: 15px; font-weight: 600; cursor: pointer; transition: all 0.2s; }
  .ef-btn-secondary:hover { border-color: #22c55e; color: #166534; background: #f0fdf4; }
  .ef-trust-items { display: flex; gap: 24px; flex-wrap: wrap; }
  .ef-trust-item { display: flex; align-items: center; gap: 8px; font-size: 13px; color: #64748b; font-weight: 500; }
  .ef-trust-check { width: 20px; height: 20px; background: #dcfce7; border-radius: 50%; display: flex; align-items: center; justify-content: center; font-size: 10px; color: #16a34a; flex-shrink: 0; }

  /* Hero Card */
  .ef-hero-card { background: #fff; border-radius: 24px; border: 1px solid #e2e8f0; padding: 32px; box-shadow: 0 24px 64px rgba(13,27,62,0.09), 0 4px 16px rgba(0,0,0,0.04); }
  .ef-card-header { display: flex; justify-content: space-between; align-items: center; margin-bottom: 20px; padding-bottom: 16px; border-bottom: 1px solid #f1f5f9; }
  .ef-card-title-label { font-size: 12px; color: #94a3b8; font-weight: 500; margin-bottom: 3px; }
  .ef-card-title-value { font-size: 15px; font-weight: 700; color: #0d1b3e; }
  .ef-card-rec { background: #f0fdf4; color: #166534; font-size: 11px; font-weight: 600; padding: 4px 10px; border-radius: 999px; }
  .ef-entity-row { display: grid; grid-template-columns: 1fr 1fr 1fr; gap: 10px; margin-bottom: 16px; }
  .ef-entity-card { border-radius: 14px; padding: 16px 12px; text-align: center; border: 1.5px solid transparent; position: relative; }
  .ef-entity-card.recommended { border-color: #22c55e; background: #f0fdf4; }
  .ef-entity-card.plain { border-color: #f1f5f9; background: #f8fafc; }
  .ef-entity-rec-tag { position: absolute; top: -10px; left: 50%; transform: translateX(-50%); background: #22c55e; color: #fff; font-size: 9px; font-weight: 700; padding: 2px 8px; border-radius: 999px; white-space: nowrap; }
  .ef-entity-icon { font-size: 22px; margin-bottom: 8px; }
  .ef-entity-name { font-size: 13px; font-weight: 700; color: #0d1b3e; margin-bottom: 4px; }
  .ef-entity-tax { font-size: 10px; color: #94a3b8; }
  .ef-card-features { display: flex; flex-direction: column; gap: 8px; }
  .ef-card-feature { display: flex; align-items: center; gap: 10px; padding: 10px 12px; background: #f8fafc; border-radius: 10px; font-size: 12.5px; color: #334155; font-weight: 500; }
  .ef-card-feature-icon { font-size: 14px; }
  .ef-card-metric { margin-top: 14px; padding: 16px 18px; background: linear-gradient(135deg, #059669, #0d9488); border-radius: 12px; display: flex; justify-content: space-between; align-items: center; }
  .ef-metric-label { font-size: 11px; color: rgba(255,255,255,0.75); margin-bottom: 3px; }
  .ef-metric-value { font-size: 22px; font-weight: 800; color: #fff; }
  .ef-metric-badge { background: rgba(255,255,255,0.2); border: 1px solid rgba(255,255,255,0.3); border-radius: 999px; padding: 4px 12px; font-size: 11px; font-weight: 600; color: #fff; }

  /* ── Stats ── */
  .ef-stats { border-top: 1px solid #f1f5f9; border-bottom: 1px solid #f1f5f9; }
  .ef-stats-grid { display: grid; grid-template-columns: repeat(4, 1fr); max-width: 1200px; margin: 0 auto; }
  @media (max-width: 768px) { .ef-stats-grid { grid-template-columns: 1fr 1fr; } }
  .ef-stat-item { padding: 36px 24px; text-align: center; border-right: 1px solid #f1f5f9; }
  .ef-stat-item:last-child { border-right: none; }
  @media (max-width: 768px) { .ef-stat-item:nth-child(2n) { border-right: none; } .ef-stat-item { border-bottom: 1px solid #f1f5f9; } }
  .ef-stat-num { font-family: 'Playfair Display', serif; font-size: 2.2rem; font-weight: 800; color: #059669; letter-spacing: -0.03em; line-height: 1; margin-bottom: 8px; }
  .ef-stat-label { font-size: 0.82rem; color: #64748b; font-weight: 500; }

  /* ── Shared ── */
  .ef-section { padding: 96px 24px; }
  .ef-container { max-width: 1200px; margin: 0 auto; }
  .ef-section-header { text-align: center; max-width: 720px; margin: 0 auto 64px; }
  .ef-section-header h2 { font-family: 'Playfair Display', serif; font-size: clamp(1.8rem, 3.5vw, 2.8rem); font-weight: 800; color: #0d1b3e; letter-spacing: -0.02em; margin-bottom: 16px; line-height: 1.2; }
  .ef-section-header p { font-size: 1.05rem; color: #64748b; line-height: 1.78; }
  .ef-kicker { font-size: 12px; font-weight: 700; letter-spacing: 0.1em; text-transform: uppercase; color: #059669; margin-bottom: 12px; }

  /* ── Entity Types Comparison ── */
  .ef-compare-bg { background: #f8fafc; border-top: 1px solid rgba(226,232,240,0.6); border-bottom: 1px solid rgba(226,232,240,0.6); }
  .ef-compare-table { width: 100%; border-collapse: collapse; }
  .ef-compare-table th { padding: 16px 20px; font-size: 13px; font-weight: 700; color: #64748b; text-align: left; border-bottom: 2px solid #e2e8f0; }
  .ef-compare-table th.entity-col { text-align: center; }
  .ef-col-header { display: flex; flex-direction: column; align-items: center; gap: 6px; }
  .ef-col-icon { font-size: 22px; }
  .ef-col-name { font-size: 14px; font-weight: 800; color: #0d1b3e; }
  .ef-col-sub { font-size: 11px; color: #94a3b8; font-weight: 400; }
  .ef-col-badge-rec { background: #f0fdf4; color: #166534; font-size: 10px; font-weight: 700; padding: 2px 8px; border-radius: 999px; border: 1px solid #bbf7d0; }
  .ef-compare-table td { padding: 15px 20px; font-size: 13.5px; color: #334155; border-bottom: 1px solid #f1f5f9; }
  .ef-compare-table td.feature-label { font-weight: 600; color: #0d1b3e; }
  .ef-compare-table td.center-cell { text-align: center; }
  .ef-compare-table tr:hover td { background: #f8fafc; }
  .ef-check-yes { color: #22c55e; font-size: 16px; }
  .ef-check-no { color: #cbd5e1; font-size: 16px; }
  .ef-check-partial { color: #f59e0b; font-size: 14px; font-weight: 600; }
  .ef-table-wrapper { background: #fff; border-radius: 20px; border: 1px solid #e2e8f0; overflow: hidden; box-shadow: 0 4px 24px rgba(0,0,0,0.04); }
  .ef-rec-col { background: rgba(34,197,94,0.04); }

  /* ── What's Included ── */
  .ef-included-grid { display: grid; grid-template-columns: repeat(3, 1fr); gap: 24px; }
  @media (max-width: 960px) { .ef-included-grid { grid-template-columns: 1fr 1fr; } }
  @media (max-width: 600px) { .ef-included-grid { grid-template-columns: 1fr; } }
  .ef-inc-card { background: #fff; padding: 32px 28px; border-radius: 18px; border: 1px solid rgba(226,232,240,0.7); box-shadow: 0 1px 4px rgba(0,0,0,0.03); transition: all 0.3s; position: relative; overflow: hidden; }
  .ef-inc-card:hover { box-shadow: 0 16px 48px rgba(0,0,0,0.08); transform: translateY(-3px); }
  .ef-inc-card::before { content: ''; position: absolute; top: 0; left: 0; right: 0; height: 3px; background: linear-gradient(90deg, #059669, #0d9488); opacity: 0; transition: opacity 0.3s; border-radius: 18px 18px 0 0; }
  .ef-inc-card:hover::before { opacity: 1; }
  .ef-inc-icon { font-size: 28px; margin-bottom: 16px; }
  .ef-inc-title { font-size: 1rem; font-weight: 700; color: #0d1b3e; margin-bottom: 10px; }
  .ef-inc-desc { font-size: 0.88rem; color: #64748b; line-height: 1.72; }

  /* ── Process ── */
  .ef-process-bg { background: #f8fafc; border-top: 1px solid rgba(226,232,240,0.6); border-bottom: 1px solid rgba(226,232,240,0.6); }
  .ef-process-grid { display: grid; grid-template-columns: repeat(4, 1fr); gap: 32px; position: relative; }
  @media (max-width: 900px) { .ef-process-grid { grid-template-columns: 1fr 1fr; } }
  @media (max-width: 600px) { .ef-process-grid { grid-template-columns: 1fr; } }
  .ef-process-grid::before { content: ''; position: absolute; top: 27px; left: 12.5%; right: 12.5%; height: 2px; background: linear-gradient(90deg, #059669, #0d9488); z-index: 0; }
  @media (max-width: 900px) { .ef-process-grid::before { display: none; } }
  .ef-process-step { text-align: center; position: relative; z-index: 1; }
  .ef-process-num { width: 56px; height: 56px; border-radius: 50%; background: #0d1b3e; color: #fff; font-size: 1rem; font-weight: 800; display: flex; align-items: center; justify-content: center; margin: 0 auto 20px; border: 4px solid #f8fafc; box-shadow: 0 0 0 2px #0d1b3e; }
  .ef-process-title { font-size: 0.95rem; font-weight: 700; color: #0d1b3e; margin-bottom: 8px; }
  .ef-process-desc { font-size: 0.85rem; color: #64748b; line-height: 1.65; }

  /* ── CTA ── */
  .ef-cta { background: linear-gradient(135deg, #0d1b3e 0%, #064e3b 60%, #0d1b3e 100%); padding: 96px 24px; position: relative; overflow: hidden; }
  .ef-cta-blob1 { position: absolute; top: -80px; right: -60px; width: 380px; height: 380px; border-radius: 50%; background: rgba(34,197,94,0.07); filter: blur(60px); pointer-events: none; }
  .ef-cta-blob2 { position: absolute; bottom: -60px; left: -40px; width: 320px; height: 320px; border-radius: 50%; background: rgba(255,255,255,0.04); filter: blur(60px); pointer-events: none; }
  .ef-cta-inner { max-width: 720px; margin: 0 auto; text-align: center; position: relative; z-index: 1; }
  .ef-cta-tag { display: inline-block; background: rgba(34,197,94,0.18); border: 1px solid rgba(34,197,94,0.35); border-radius: 999px; padding: 6px 16px; font-size: 12px; font-weight: 700; color: #86efac; letter-spacing: 0.08em; text-transform: uppercase; margin-bottom: 24px; }
  .ef-cta h2 { font-family: 'Playfair Display', serif; font-size: clamp(2rem, 4vw, 3rem); font-weight: 800; color: #fff; margin-bottom: 20px; line-height: 1.2; letter-spacing: -0.02em; }
  .ef-cta p { font-size: 1.1rem; color: rgba(255,255,255,0.78); line-height: 1.75; margin-bottom: 44px; }
  .ef-cta-btn-group { display: flex; gap: 16px; justify-content: center; flex-wrap: wrap; margin-bottom: 36px; }
  .ef-cta-btn-primary { padding: 16px 32px; background: #22c55e; color: #fff; border: none; border-radius: 10px; font-size: 16px; font-weight: 700; cursor: pointer; transition: all 0.2s; }
  .ef-cta-btn-primary:hover { background: #16a34a; transform: translateY(-2px); box-shadow: 0 8px 24px rgba(34,197,94,0.4); }
  .ef-cta-btn-secondary { padding: 16px 32px; background: transparent; color: #fff; border: 1.5px solid rgba(255,255,255,0.35); border-radius: 10px; font-size: 16px; font-weight: 600; cursor: pointer; transition: all 0.2s; }
  .ef-cta-btn-secondary:hover { border-color: rgba(255,255,255,0.65); background: rgba(255,255,255,0.07); }
  .ef-cta-reassurances { display: flex; gap: 24px; justify-content: center; flex-wrap: wrap; }
  .ef-cta-reassurance { display: flex; align-items: center; gap: 8px; font-size: 13px; color: rgba(255,255,255,0.7); font-weight: 500; }
  .ef-cta-check { width: 18px; height: 18px; background: rgba(34,197,94,0.22); border-radius: 50%; display: flex; align-items: center; justify-content: center; font-size: 9px; color: #86efac; flex-shrink: 0; }
`;

const comparisonRows = [
  { feature: "Personal Liability Protection", llc: "yes", scorp: "yes", ccorp: "yes" },
  { feature: "Pass-Through Taxation", llc: "yes", scorp: "yes", ccorp: "no" },
  { feature: "Self-Employment Tax Savings", llc: "no", scorp: "yes", ccorp: "partial" },
  { feature: "Investor-Ready Structure", llc: "partial", scorp: "partial", ccorp: "yes" },
  { feature: "Flexible Management", llc: "yes", scorp: "no", ccorp: "no" },
  { feature: "Unlimited Shareholders", llc: "yes", scorp: "no", ccorp: "yes" },
  { feature: "Best For Startups", llc: "yes", scorp: "partial", ccorp: "partial" },
];

const included = [
  { icon: "📋", title: "Entity Name Search & Reservation", desc: "We verify name availability and reserve your chosen business name before any state filings begin." },
  { icon: "📑", title: "Articles of Incorporation / Organization", desc: "Professionally drafted and filed with the correct state agency — error-free and on time." },
  { icon: "🔢", title: "EIN Application (Federal Tax ID)", desc: "We obtain your Employer Identification Number from the IRS so you can open bank accounts and hire employees." },
  { icon: "📖", title: "Operating Agreement or Bylaws", desc: "Custom-drafted governance documents that define ownership, voting rights, and operational rules." },
  { icon: "📬", title: "Registered Agent Service (1 Year)", desc: "We handle your registered agent requirements so legal notices are never missed." },
  { icon: "✅", title: "Post-Formation Compliance Checklist", desc: "A curated checklist of next steps — licenses, permits, bank accounts, and state-specific requirements." },
];

const processSteps = [
  { num: "01", title: "Free Strategy Call", desc: "We learn about your business, goals, and situation to recommend the ideal entity type." },
  { num: "02", title: "Entity Selection", desc: "We present a clear recommendation with a side-by-side comparison tailored to your needs." },
  { num: "03", title: "Filing & Formation", desc: "We handle all paperwork, state filings, and federal registrations on your behalf." },
  { num: "04", title: "You're Ready to Operate", desc: "Receive your formation documents, EIN, and compliance checklist. Start doing business confidently." },
];

const LegalEntityFormation = () => {
  const { navigateTo } = useNavigation();

  return (
    <div className="ef-page">
      <style>{styles}</style>

      {/* ── Hero ── */}
      <section className="ef-hero">
        <div className="ef-hero-blob1" />
        <div className="ef-hero-blob2" />
        <div className="ef-hero-inner">
          <div>
            <button className="ef-back-btn" onClick={() => navigateTo("")}>← Back to Legal Services</button>
            <div className="ef-badge">
              <span className="ef-badge-dot" />
              Business Entity Formation
            </div>
            <h1>
              Form Your Business{" "}
              <span className="ef-gradient-text">the Right Way</span>
            </h1>
            <p className="ef-hero-sub">
              Choosing the right legal structure is one of the most important
              decisions you'll make. We guide you through LLC, S-Corp, and C-Corp
              formation — handling every filing so you can focus on building.
            </p>
            <div className="ef-btn-group">
              <button className="ef-btn-primary">Start My Formation →</button>
              <button className="ef-btn-secondary">Compare Entity Types</button>
            </div>
            <div className="ef-trust-items">
              {["Formation in as little as 48 hrs", "All 50 states covered", "Flat-rate pricing", "Expert guidance included"].map((t, i) => (
                <div key={i} className="ef-trust-item">
                  <span className="ef-trust-check">✓</span>
                  {t}
                </div>
              ))}
            </div>
          </div>

          <div className="ef-hero-card">
            <div className="ef-card-header">
              <div>
                <div className="ef-card-title-label">Entity Recommendation</div>
                <div className="ef-card-title-value">For Your Business Profile</div>
              </div>
              <span className="ef-card-rec">✓ AI-Matched</span>
            </div>
            <div className="ef-entity-row">
              {[
                { icon: "🏠", name: "LLC", tax: "Pass-through", rec: true },
                { icon: "📊", name: "S-Corp", tax: "Pass-through", rec: false },
                { icon: "🏦", name: "C-Corp", tax: "Double taxed", rec: false },
              ].map((e, i) => (
                <div key={i} className={`ef-entity-card ${e.rec ? "recommended" : "plain"}`}>
                  {e.rec && <div className="ef-entity-rec-tag">★ Best Fit</div>}
                  <div className="ef-entity-icon">{e.icon}</div>
                  <div className="ef-entity-name">{e.name}</div>
                  <div className="ef-entity-tax">{e.tax}</div>
                </div>
              ))}
            </div>
            <div className="ef-card-features">
              {[
                { icon: "🛡️", text: "Personal liability protection" },
                { icon: "💰", text: "Pass-through tax benefits" },
                { icon: "⚡", text: "Minimal ongoing compliance" },
              ].map((f, i) => (
                <div key={i} className="ef-card-feature">
                  <span className="ef-card-feature-icon">{f.icon}</span>
                  {f.text}
                </div>
              ))}
            </div>
            <div className="ef-card-metric">
              <div>
                <div className="ef-metric-label">Formations Completed</div>
                <div className="ef-metric-value">2,400+</div>
              </div>
              <div className="ef-metric-badge">All 50 States</div>
            </div>
          </div>
        </div>
      </section>

      {/* ── Stats ── */}
      <section className="ef-stats">
        <div className="ef-stats-grid">
          {[
            { num: "2,400+", label: "Businesses Formed" },
            { num: "48 hrs", label: "Average Turnaround" },
            { num: "All 50", label: "States Covered" },
            { num: "99%", label: "Filing Accuracy Rate" },
          ].map((s, i) => (
            <div key={i} className="ef-stat-item">
              <div className="ef-stat-num">{s.num}</div>
              <div className="ef-stat-label">{s.label}</div>
            </div>
          ))}
        </div>
      </section>

      {/* ── Comparison Table ── */}
      <section className="ef-section ef-compare-bg">
        <div className="ef-container">
          <div className="ef-section-header">
            <div className="ef-kicker">Entity Comparison</div>
            <h2>LLC vs. S-Corp vs. C-Corp</h2>
            <p>
              Not sure which structure is right for you? We break down the key
              differences so you can make an informed decision — or let us
              recommend the best fit based on your goals.
            </p>
          </div>
          <div className="ef-table-wrapper">
            <table className="ef-compare-table">
              <thead>
                <tr>
                  <th style={{ width: "34%" }}>Feature</th>
                  <th className="entity-col" style={{ width: "22%" }}>
                    <div className="ef-col-header">
                      <span className="ef-col-icon">🏠</span>
                      <span className="ef-col-name">LLC</span>
                      <span className="ef-col-badge-rec">★ Most Popular</span>
                    </div>
                  </th>
                  <th className="entity-col" style={{ width: "22%" }}>
                    <div className="ef-col-header">
                      <span className="ef-col-icon">📊</span>
                      <span className="ef-col-name">S-Corp</span>
                      <span className="ef-col-sub">Tax savings</span>
                    </div>
                  </th>
                  <th className="entity-col" style={{ width: "22%" }}>
                    <div className="ef-col-header">
                      <span className="ef-col-icon">🏦</span>
                      <span className="ef-col-name">C-Corp</span>
                      <span className="ef-col-sub">Investor-ready</span>
                    </div>
                  </th>
                </tr>
              </thead>
              <tbody>
                {comparisonRows.map((row, i) => (
                  <tr key={i}>
                    <td className="feature-label">{row.feature}</td>
                    <td className="center-cell ef-rec-col">
                      {row.llc === "yes" ? <span className="ef-check-yes">✓</span> : row.llc === "no" ? <span className="ef-check-no">✕</span> : <span className="ef-check-partial">~</span>}
                    </td>
                    <td className="center-cell">
                      {row.scorp === "yes" ? <span className="ef-check-yes">✓</span> : row.scorp === "no" ? <span className="ef-check-no">✕</span> : <span className="ef-check-partial">~</span>}
                    </td>
                    <td className="center-cell">
                      {row.ccorp === "yes" ? <span className="ef-check-yes">✓</span> : row.ccorp === "no" ? <span className="ef-check-no">✕</span> : <span className="ef-check-partial">~</span>}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </section>

      {/* ── What's Included ── */}
      <section className="ef-section">
        <div className="ef-container">
          <div className="ef-section-header">
            <div className="ef-kicker">What's Included</div>
            <h2>Everything You Need to Launch Legally</h2>
            <p>
              Our formation package covers every step from name reservation to
              post-formation compliance — one flat rate, no hidden fees.
            </p>
          </div>
          <div className="ef-included-grid">
            {included.map((item, i) => (
              <div key={i} className="ef-inc-card">
                <div className="ef-inc-icon">{item.icon}</div>
                <div className="ef-inc-title">{item.title}</div>
                <div className="ef-inc-desc">{item.desc}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── Process ── */}
      <section className="ef-section ef-process-bg">
        <div className="ef-container">
          <div className="ef-section-header">
            <div className="ef-kicker">How It Works</div>
            <h2>From Decision to Formation in 4 Steps</h2>
            <p>We make business formation straightforward and stress-free.</p>
          </div>
          <div className="ef-process-grid">
            {processSteps.map((step, i) => (
              <div key={i} className="ef-process-step">
                <div className="ef-process-num">{step.num}</div>
                <div className="ef-process-title">{step.title}</div>
                <div className="ef-process-desc">{step.desc}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── CTA ── */}
      <section className="ef-cta">
        <div className="ef-cta-blob1" />
        <div className="ef-cta-blob2" />
        <div className="ef-cta-inner">
          <div className="ef-cta-tag">Get Started Today</div>
          <h2>Ready to Make It Official?</h2>
          <p>
            Start your business formation today. Our legal team handles everything
            — from state filings to your EIN — so you can focus on what you do
            best.
          </p>
          <div className="ef-cta-btn-group">
            <button className="ef-cta-btn-primary">Start My Formation</button>
            <button className="ef-cta-btn-secondary">Talk to an Attorney</button>
          </div>
          <div className="ef-cta-reassurances">
            {["Flat-rate pricing", "All 50 states", "48-hr turnaround", "No hidden fees"].map((r, i) => (
              <div key={i} className="ef-cta-reassurance">
                <span className="ef-cta-check">✓</span>
                {r}
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default LegalEntityFormation;
